/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pesticide_Quarantine_PeriodInputs */

const vi_pesticide_quarantine_period = /** @type {(inputs: Pesticide_Quarantine_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời gian cách ly`)
};

/**

* @param {Pesticide_Quarantine_PeriodInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pesticide_quarantine_period = /** @type {((inputs?: Pesticide_Quarantine_PeriodInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pesticide_Quarantine_PeriodInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pesticide_quarantine_period(inputs)
});